"use client";

import Script from "next/script";
import { useEffect, useState } from "react";

//#region [Props]
type MailChimpScriptsProps = {
    envName?: string;
};
//#endregion

//#region [Component]
export default function MailChimpScripts({ envName }: MailChimpScriptsProps) {
    const [doRender, setRender] = useState(false);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- render the scripts on the client only, after hydration
        setRender(true);
    }, []);
    //console.debug("ENV NAME", envName);
    if (!doRender || !envName) {
        return null;
    }
    return <>
        {envName === "PROD" && <Script strategy="lazyOnload" id="mcjs">{`!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/e0cead56b303960f1671cd15c/0a1da376d8c507254d7d1421c.js");`}</Script>}
        {envName === "TEST" && <Script  strategy="lazyOnload" id="mcjs">{`!function(c,h,i,m,p){m=c.createElement(h),p=c.getElementsByTagName(h)[0],m.async=1,m.src=i,p.parentNode.insertBefore(m,p)}(document,"script","https://chimpstatic.com/mcjs-connected/js/users/e0cead56b303960f1671cd15c/b5848b85b33750837e3dcd8fb.js");`}</Script>}
    </>;
}
//#endregion
